import fc from '@/firebaseConfig'

export default {
  namespaced: true,
  state: {
    loading: false,
    list: [],
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val
    },
    setList(state, val) {
      state.list = val
    },
  },
  actions: {
    async getList({ commit }, { companyId, shopId }) {
      commit('setLoading', true)
      const snapshot = await fc.db.collection("Companies").doc(companyId)
        .collection('Shops').doc(shopId)
        .collection('Channels').get()
      let list = []
      snapshot.forEach((doc) => {
        let data = doc.data()
        data.id = doc.id
        list.push(data)
      });
      commit('setList', list)
      commit('setLoading', false)
      console.log('list: ', list)
      return list
    },
    async save(_, { companyId, shopId, channel }) {
      const collection = fc.db.collection("Companies").doc(companyId)
        .collection('Shops').doc(shopId)
        .collection('Channels')

      const doc = channel.id ? collection.doc(channel.id) : collection.doc()
      await doc.set(channel, { merge: true })
      return doc.id
    },
    async remove(_, { companyId, shopId, channelId }) {
      await fc.db.collection("Companies").doc(companyId)
        .collection('Shops').doc(shopId)
        .collection('Channels').doc(channelId)
        .delete()
    }
  }
}

